export const types = {
  LEGAL: 'legal',
  ALBUM: 'album',
};

export function isAlbum(type: string): boolean {
  return (type === types.ALBUM);
}
